export interface DisturbanceTableData extends DisturbanceTableRows {
  isLoaded: boolean;
}

export enum DisturbanceBusinessArea {
  MOB_RAN = 'MOB_RAN'
}

export enum DisturbanceType {
  ChangeDisturbanceInfo = 'ChangeDisturbanceInfo',
  IncidentDisturbanceInfo = 'IncidentDisturbanceInfo',
  ProblemDisturbanceInfo = 'ProblemDisturbanceInfo'
}

export enum DisturbanceStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  DEADEND = 'DEADEND'
}

export enum DisturbanceArea {
  FIX = 'FIX',
  MOB_VAS = 'MOB (VAS)',
  MOB_RAN = 'MOB (RAN)',
  IT = 'IT',
  TV = 'TV',
  NOT_SET = 'NOT_SET'
}

export enum DisturbanceRegion {
  HARJUMAA = 'HARJUMAA',
  HIIUMAA = 'HIIUMAA',
  IDA_VIRUMAA = 'IDA_VIRUMAA',
  JOGEVAMAA = 'JOGEVAMAA',
  JARVAMAA = 'JARVAMAA',
  LAANEMAA = 'LAANEMAA',
  LAANE_VIRUMAA = 'LAANE_VIRUMAA',
  POLVAMAA = 'POLVAMAA',
  PARNUMAA = 'PARNUMAA',
  RAPLAMAA = 'RAPLAMAA',
  SAAREMAA = 'SAAREMAA',
  TARTUMAA = 'TARTUMAA',
  VALGAMAA = 'VALGAMAA',
  VILJANDIMAA = 'VILJANDIMAA',
  VORUMAA = 'VORUMAA'
}

export enum DisturbanceRegionFull {
  HARJUMAA = 'map.county.harjumaa',
  HIIUMAA = 'map.county.hiiumaa',
  IDA_VIRUMAA = 'map.county.ida.virumaa',
  JOGEVAMAA = 'map.county.jogevamaa',
  JARVAMAA = 'map.county.jarvamaa',
  LAANEMAA = 'map.county.laanemaa',
  LAANE_VIRUMAA = 'map.county.laane.virumaa',
  POLVAMAA = 'map.county.polvamaa',
  PARNUMAA = 'map.county.parnumaa',
  RAPLAMAA = 'map.county.raplamaa',
  SAAREMAA = 'map.county.saaremaa',
  TARTUMAA = 'map.county.tartumaa',
  VALGAMAA = 'map.county.valgamaa',
  VILJANDIMAA = 'map.county.viljandimaa',
  VORUMAA = 'map.county.vorumaa'
}

export enum DisturbanceTabId {
  INCIDENT = 'tab-incidents',
  CHANGE = 'tab-changes',
  PROBLEM = 'tab-problems'
}

export interface DisturbanceTableRows {
  data: Disturbance[];
  type: DisturbanceType;
  offset: DisturbanceOffset;
}

export interface DisturbanceOffset {
  prevPage: number;
  currentPage: number;
  nextPage: number;
}

export interface DisturbanceInfoText {
  infoText: string;
  languageCode: string;
}

export interface DisturbanceRelatedEntity {
  name: string;
  siaId: string;
  address: string;
}

export interface DisturbanceDevice {
  refDeviceManufacturer: string;
  refDeviceModel: string;
  refDeviceId: string;
}

export interface DisturbanceLocation {
  name: string;
  f4g: boolean;
  serviceName: string;
  serviceId: string;
}

export interface Disturbance {
  id: string;
  disturbanceId: string;
  state: string;
  heading: string;
  description: string;
  start: string;
  plannedStart: string;
  end: string;
  plannedEnd: string;
  serviceInfo: DisturbanceInfoText[];
  areas: string[];
  location: DisturbanceLocation[];
  affected: number;
  workaround: string;
  status: string;
  resolution: string;
  primaryCause: string;
  relatedEntity: DisturbanceRelatedEntity[];
  devices: DisturbanceDevice[];
  riskOfDisruption: boolean;
  totalDurationOfDisruption: number;
  hiddenFromCustomer: boolean;
  isExpandable: boolean;
}

export interface DisturbanceMapDisturbance {
  informationalId: string;
  type: DisturbanceType.IncidentDisturbanceInfo | DisturbanceType.ChangeDisturbanceInfo;
  serviceInfo: DisturbanceInfoText[];
  start: string;
  plannedEnd: string;
  actualEnd: string;
  impactedCustomersCount: number;
}

export interface DisturbanceMapArea {
  areaName: string;
  disturbances: DisturbanceMapDisturbance[];
  disturbancesCount: number;
}

export interface DisturbanceMapCounty {
  countyName: string;
  countyKey: DisturbanceRegion;
  affectedAreas: DisturbanceMapArea[];
  disturbancesCount: number;
}

export interface DisturbanceMap {
  disturbanceCounties: DisturbanceMapCounty[];
  refreshTime: string;
}

export interface DisturbanceNotice {
  informationalId: string;
  countyNotification: DisturbanceInfoText[];
}

export interface DisturbanceLocalNotifications {
  countyName: string;
  noticeCount: number;
  notices: DisturbanceNotice[];
}

export interface DisturbanceNotifications {
  globalNotices: DisturbanceNotice[];
  localNotices: DisturbanceLocalNotifications[];
}

export interface DisturbanceTabs {
  changes: number;
  problems: number;
  incidents: number;
}
